import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import axios from "axios";

// material-ui components
import { makeStyles } from "@material-ui/core/styles";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from 'components/Grid/GridItem.js';

import FormControl from "@material-ui/core/FormControl";
import CustomInput from "components/CustomInput/CustomInput";

// @material-ui/icons
import Close from "@material-ui/icons/Close";
import { infoColor } from "assets/jss/material-dashboard-pro-react.js";

// core components
import Button from "components/CustomButtons/Button.js";
import Confirm from 'views/component/Confirm.js';

import modalStyle from "assets/jss/material-dashboard-pro-react/modalStyle.js";
import selectStyles from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";

const customStyle = {
    right: { float: 'right' },
    modalTitle: { color: infoColor[0], fontWeight: 'bold' },
    modalHeader: { borderBottom: '2px solid ' + infoColor[0] },
    select: { minWidth: '200px' }
}
const defaultStyles = makeStyles(selectStyles);
const useStyles = makeStyles(modalStyle);
const customStyles = makeStyles(customStyle);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

export default function ScenarioCopyPopup(props) {
    const { location, testcase, onTestcaseChange, modal, onClose } = props;
    
    const classes = { ...useStyles(), ...defaultStyles(), ...customStyles() };
    const history = useHistory();

    const [copyTarget, setCopyTarget] = useState(testcase.name);
    const [copyConfirmShow, showCopyConfirm] = useState(false);

    useEffect(() => {
        if(testcase.name) {
            setCopyTarget('[개선] ' + testcase.name);
        }
    }, [testcase]);

    const setModal = function (modal) {
        onClose(modal);
    }

    const handleCopy = function (result) {
        if (result) {
            axios.post('data/testcase/copy', { targetName: copyTarget, testcaseId: testcase.testcaseId }).then(response => {
                onTestcaseChange();
                setModal(false);
                history.replace('../testcase/info', {
                    'projectId': location.state.projectId,
                    'scenarioId': location.state.scenarioId,
                    'testcaseId': response.data
                });
            });
        }
        showCopyConfirm(false);
    }

    return (
        <Dialog classes={{ root: classes.center, paper: classes.modal }}
            open={modal} transition={Transition} keepMounted
            onClose={() => setModal(false)}
            aria-labelledby="modal-slide-title" aria-describedby="modal-slide-description" >
            <DialogTitle id="classic-modal-slide-title" disableTypography className={classes.modalHeader}>
                <Button justIcon className={classes.modalCloseButton} key="close"
                    aria-label="Close" color="transparent" onClick={() => setModal(false)}>
                    <Close className={classes.modalClose} />
                </Button>
                <h4 className={classes.modalTitle}>개선시나리오 생성</h4>
            </DialogTitle>
            <DialogContent id="modal-slide-description" className={classes.modalBody}>
                <GridContainer justify="center">
                    <GridItem>
                        <FormControl fullWidth className={classes.selectFormControlInfo}>
                            <CustomInput labelText={"시나리오 명"} formControlProps={{ fullWidth: true }}
                                        inputProps={{
                                            value: copyTarget,
                                            type: 'text',
                                            onChange: e => setCopyTarget(e.target.value)
                                        }}
                                        labelProps={{ shrink: testcase.name ? true : false }}
                                        underlineColor="info" />
                        </FormControl>
                        <Button fullWidth color='info' onClick={() => { if (copyTarget) showCopyConfirm(true) }}>생성</Button>
                        <Confirm show={copyConfirmShow} title="개선 시나리오 생성" text="새로운 시나리오를 생성합니다."
                            onConfirm={handleCopy} confirmText="확인" type='info' />
                    </GridItem>
                </GridContainer>
            </DialogContent>
        </Dialog>
    );
}